import React, { useContext, useState, useEffect } from 'react';
import './CartItems.css';
import { ShopContext } from '../../Context/ShopContext';
import { toast } from 'react-toastify';
import { FiPlus, FiMinus, FiTrash2, FiShoppingCart, FiChevronRight } from 'react-icons/fi';
import { Link, useNavigate } from 'react-router-dom';
import ShopStatusBanner from '../ShopStatusBanner/ShopStatusBanner';

const PhoneToast = () => {
    const navigate = useNavigate();
    const goToProfile = () => {
        navigate('/profile');
        toast.dismiss();
    };
    return (
        <div>
            <p>Please add a phone number to continue.</p>
            <button className="toast-action-button" onClick={goToProfile}>
                Go to Profile
            </button>
        </div>
    );
};
const FreeVadaCard = () => { //remove when promo ends
    return (
        <div className="cart-item-card free-item-card">
            <img
                src="https://placehold.co/100x100/f5d2b9/8c5a3c?text=Free+Vada"
                alt="Free Vada"
                className="cart-item-image"
            />
            <div className="cart-item-details">
                <p className="cart-item-name">Vada (Free)</p>
                <p className="cart-item-price">
                    ₹0.00
                    <span className="free-item-badge">PROMO</span>
                </p>
            </div>
            <div className="cart-item-actions">
                <div className="quantity-controls">
                    <span>1</span>
                </div>
            </div>
        </div>
    );
};
// remove when promo ends
const CartItems = () => {
    const {
        all_products, cartItems, addToCart, removeFromCart, handleCheckout,
        getTotalAmount, getDeliveryCharge, getTotalCartAmountWithDelivery,
        shopStatus, loading, deliverySettings, user
    } = useContext(ShopContext);

    const isShopOpen = shopStatus?.isShopCurrentlyOpen;

    const [deliveryLocation, setDeliveryLocation] = useState(
        () => localStorage.getItem('deliveryLocation') || ''
    );

    const [isCheckingOut, setIsCheckingOut] = useState(false);
    const [subtotal, setSubtotal] = useState(0);
    const [deliveryFee, setDeliveryFee] = useState(0);
    const [finalTotal, setFinalTotal] = useState(0);

    const deliveryOptions = deliverySettings?.mode === 'locations'
        ? ['Shop Pickup', ...(deliverySettings.locations || []).map(l => l.name)]
        : ['Shop Pickup'];

    const cartProducts = all_products.filter(product => cartItems[product._id] > 0);

    useEffect(() => {
        if (loading) return;
        const currentSubtotal = getTotalAmount();
        const currentDeliveryFee = getDeliveryCharge(deliveryLocation);
        const currentFinalTotal = getTotalCartAmountWithDelivery(deliveryLocation);

        setSubtotal(currentSubtotal);
        setDeliveryFee(currentDeliveryFee);
        setFinalTotal(currentFinalTotal);
    }, [cartItems, deliveryLocation, all_products, loading, getTotalAmount, getDeliveryCharge, getTotalCartAmountWithDelivery]);


    useEffect(() => {
        if (deliveryLocation) {
            localStorage.setItem('deliveryLocation', deliveryLocation);
        } else {
            localStorage.removeItem('deliveryLocation');
        }
    }, [deliveryLocation]);

    const handleProceedToCheckout = async () => {
        if (!isShopOpen) {
            const formatTime = (time24) => {
                if (!time24 || typeof time24 !== 'string') return '';
                const [hour, minute] = time24.split(':');
                const h = parseInt(hour, 10);
                const ampm = h >= 12 ? 'PM' : 'AM';
                const formattedHour = h % 12 || 12;
                return `${formattedHour}:${minute} ${ampm}`;
            };
            toast.error(`Sorry, the shop is currently closed. Open from ${formatTime(shopStatus.shopOpenTime)} to ${formatTime(shopStatus.shopCloseTime)}.`);
            return;
        }

        if (subtotal <= 0) {
            toast.warn("Your cart is empty!");
            return;
        }

        const isLocationMode = deliverySettings?.mode === 'locations';
        const isAddressMode = deliverySettings?.mode === 'address';

        if (isLocationMode && !deliveryLocation) {
            toast.error('Please select a delivery location before proceeding.');
            return;
        }

        if (isAddressMode && !deliveryLocation && !user?.defaultAddress) {
            toast.error('Please add a delivery address before proceeding.');
            return;
        }

        setIsCheckingOut(true);
        try {
            const checkoutResult = await handleCheckout(deliveryLocation);
            if (checkoutResult?.code === 'PHONE_REQUIRED') {
                toast.warn(<PhoneToast />, { autoClose: 5000 });
            } else if (checkoutResult && !checkoutResult.success) {
                toast.error(checkoutResult.error || "Failed to place order.");
            }
        } catch (error) {
            toast.error("An unexpected error occurred during checkout.");
        } finally {
            setIsCheckingOut(false);
        }
    };


    if (!loading && cartProducts.length === 0) {
        if (deliveryLocation !== '') {
            setDeliveryLocation('');
        }

        return (
            <div className="cart-empty">
                <FiShoppingCart size={80} className="cart-empty-icon" />
                <h2>Your Cart is Empty</h2>
                <p>Looks like you haven't added anything to your cart yet.</p>
                <Link to="/" className="cart-empty-button">Start Shopping</Link>
            </div>
        );
    }


    if (loading) {
        return (
            <div className="cart-page container">
                <h1>Your Cart</h1>
                <p>Loading cart items...</p>
            </div>
        );
    }

    return (
        <>
            <div className="cart-page container">
                <h1>Your Cart</h1>
                <ShopStatusBanner status={shopStatus} loading={loading} />

                <div className="cart-items-list">
                    {cartProducts.map((product) => (
                        <div key={product._id} className="cart-item-card">
                            <img src={product.imageUrl} alt={product.name} className="cart-item-image" />
                            <div className="cart-item-details">
                                <p className="cart-item-name">{product.name}</p>
                                <p className="cart-item-price">₹{product.price}</p>
                            </div>
                            <div className="cart-item-actions">
                                <div className="quantity-controls">
                                    <button onClick={() => removeFromCart(product._id)}><FiMinus /></button>
                                    <span>{cartItems[product._id]}</span>
                                    <button onClick={() => addToCart(product._id)}><FiPlus /></button>
                                </div>
                                <FiTrash2
                                    className="cart-item-remove-icon"
                                    onClick={() => removeFromCart(product._id, 'all')}
                                />
                            </div>
                        </div>
                    ))}
                    {subtotal > 0 && <FreeVadaCard />}  {/* remove when promo ends */}
                </div>
            </div>

            <div className="floating-checkout-bar">
                {deliverySettings?.mode === 'locations' ? (
                    <div className="location-selector">
                        <label htmlFor="delivery-select">Deliver to:</label>
                        <select
                            id="delivery-select"
                            value={deliveryLocation}
                            onChange={(e) => setDeliveryLocation(e.target.value)}
                        >
                            <option value="" disabled>Select Location</option>
                            {deliveryOptions.map(option => (
                                <option key={option} value={option}>{option}</option>
                            ))}
                        </select>
                    </div>
                ) : (
                    <div className="address-selector">
                        <div
                            className="address-info-box"
                            onClick={() => deliveryLocation === 'Shop Pickup' && setDeliveryLocation('')}
                        >
                            <label>Delivery Address:</label>
                            {deliveryLocation === 'Shop Pickup' ? (
                                <p className="address-preview">Picking up from Shop</p>
                            ) : user?.defaultAddress ? (
                                <div className="address-preview">
                                    <strong>{user.defaultAddress.name}</strong>
                                    <p>{user.defaultAddress.addressLine1}, {user.defaultAddress.district}</p>
                                </div>
                            ) : (
                                <p className="address-preview placeholder">No address added yet</p>
                            )}
                        </div>
                        <div className="address-actions-row">
                            <button
                                className={`pickup-toggle-btn ${deliveryLocation === 'Shop Pickup' ? 'active' : ''}`}
                                onClick={() => setDeliveryLocation(deliveryLocation === 'Shop Pickup' ? '' : 'Shop Pickup')}
                            >
                                {deliveryLocation === 'Shop Pickup' ? 'Deliver to Address' : 'Self Pickup'}
                            </button>
                            {deliveryLocation !== 'Shop Pickup' && (
                                <Link to="/address" className="change-address-link">
                                    {user?.defaultAddress ? 'Change' : 'Add'}
                                </Link>
                            )}
                        </div>
                    </div>
                )}

                <div className="checkout-summary-details">
                    <div className="summary-item">
                        <p>Subtotal</p>
                        <p>₹{subtotal.toFixed(2)}</p>
                    </div>
                    <div className="summary-item">
                        <p>Delivery Fee</p>
                        <p>
                            {deliveryLocation === 'Shop Pickup'
                                ? 'Free'
                                : (deliverySettings?.mode === 'locations' && deliveryLocation === '')
                                    ? 'Select Location'
                                    : (deliveryFee > 0 ? `₹${deliveryFee.toFixed(2)}` : 'Free')}
                        </p>

                    </div>
                    <hr className="summary-divider-bar" />
                    <div className="summary-total-bar">
                        <h3>Total</h3>
                        <h3>₹{finalTotal.toFixed(2)}</h3>
                    </div>
                </div>

                <div className="checkout-action">
                    <button
                        onClick={handleProceedToCheckout}
                        className="checkout-button"
                        disabled={
                            isCheckingOut ||
                            subtotal <= 0 ||
                            !isShopOpen ||
                            (!deliveryLocation && deliverySettings?.mode === 'locations') ||
                            (deliverySettings?.mode === 'address' && !deliveryLocation && !user?.defaultAddress)
                        }
                    >
                        {isCheckingOut ? 'Processing...' : (
                            <>
                                <span>Pay ₹{finalTotal.toFixed(2)}</span>
                                <FiChevronRight size={22} />
                            </>
                        )}
                    </button>
                    {!isShopOpen && <p className="shop-closed-message-cart">Shop is currently closed</p>}
                </div>
            </div>
        </>
    );
};

export default CartItems;
